const mapping = {
  name: "like",
  id: "eq",
  project: "eq",
  createdAt: "gte,lte",
  updatedAt: "gte,lte",
};

export const createFilterQuery = (
  filter: Array<{ id: string; value: any }>
) => {
  const query = filter.map(f => {
    const { id, value } = f;
    const type = mapping[id];
    if (type === "like") {
      return `${id}:${type}=${value}`;
    }
    if (type === "eq") {
      return `${id}:${type}=${value}`;
    }
    if (type === "gte,lte") {
      const [start, end] = type.split(",");
      return `${id}:${start}=${value.startDate},${id}:${end}=${value.endDate}`;
    }

    return "";
  });
  return query.join(",");
};
